import {ApiClientService, EntityApiService} from '@dofleini/security';

class EmployeesApiService extends EntityApiService {

    searchUsers = (params) => {
      return ApiClientService.post(this.getPath('/search-users'), params);
    };

}

export default new EmployeesApiService('/ms-core/api/workers');
